import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { extendMoment } from "moment-range";
import Moment from "moment";
import GlobalContext from "../../context/GlobalContext";
import db from "../../Firebase";
import { handleLogout } from "../../Utility";
import { useInventoryContext } from "./InventoryContext";
import { Button } from "react-bootstrap";
import useFetchUserRole from "./useFetchUserRole";
import { doc, getDoc, setDoc, updateDoc, getDocs, collection, onSnapshot, query, where } from "firebase/firestore";
import moment from "moment";

// Unique key for a row = product name
const getRowKey = (row) => row.product_name;

// Stock Need = kitna aur chahiye. Kabhi negative nahi.
const calcNeed = (finalOrder, stock) =>
  Math.max(0, (Number(finalOrder) || 0) - (Number(stock) || 0));

// Reusable component for B2B and Buffer inputs with Enter confirmation
const toCellString = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? String(Math.round(n)) : "0";
};

const EditableCell = ({ initialValue, onSave, disabled, allowNegative = false }) => {
  const [value, setValue] = useState(toCellString(initialValue));

  useEffect(() => {
    setValue(toCellString(initialValue));
  }, [initialValue]);

  // Only allow digits (and a leading minus when negatives are allowed)
  const handleChange = (e) => {
    const raw = e.target.value;
    const pattern = allowNegative ? /^-?\d*$/ : /^\d*$/;
    if (pattern.test(raw)) setValue(raw);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.target.blur(); // Trigger blur to save
      return;
    }
    // Block Up/Down arrow keys — browsers use these to
    // increment/decrement a number input by default.
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  const handleBlur = () => {
    let parsed = parseInt(value, 10);
    if (isNaN(parsed)) parsed = 0;

    setValue(parsed.toString()); // Format visually to clean '00' or empty state
    if (parsed !== (Number(initialValue) || 0)) {
      onSave(parsed);
    }
  };

  // Stop mouse-wheel from incrementing/decrementing the value while
  // the page is being scrolled over this input.
  const handleWheel = (e) => {
    e.target.blur();
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      className="form-control text-center mx-auto no-spinner"
      value={value}
      onChange={handleChange}
      onFocus={(e) => e.target.select()}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      onWheel={handleWheel}
      style={{
        width: "90%",
        maxWidth: "140px",
        minWidth: "100px", // 4-5 digit values (e.g. 1000, 10000) fit fully
        padding: "0.375rem 0.25rem", // less side padding so digits aren't clipped
        color: "#212529",
        backgroundColor: disabled ? "#e9ecef" : "#fff",
      }}
      disabled={disabled}
    />
  );
};

const Orders = () => {
  const {
    products,
    user,
    setUser,
    bufferPercentage,
    setBufferPercentage,
    setLoading,
    stockData,
    hubs,
    B2BPridiction,
    cummulativeDeliveryList,
    setCummulativeDeliveryList,
    hubProducts,
    setHubWiesProduct,
  } = useInventoryContext();

  const [selectedHub, setSelectedHub] = useState("All Hub");
  const [isLocked, setIsLocked] = useState(false);
  const [lockedAt, setLockedAt] = useState(null)
  const [FilteredHubDeliveryList, setFilteredHubDeliveryList] = useState([])
  const [deliveryList, setDeliveryList] = useState([]);
  const [cummulativeDeliveryList1, setCummulativeDeliveryList1] = useState(cummulativeDeliveryList || []);
  // Manually saved stock values (from the "stockUpdates" collection), keyed by `${hub}__${product_name}`
  const [stockOverrides, setStockOverrides] = useState({});

  // Load today's saved stock updates (live)
  useEffect(() => {
    const todayDate = moment().format("YYYY-MM-DD");
    const q = query(collection(db, "stockUpdates"), where("date", "==", todayDate));
    const unsub = onSnapshot(
      q,
      (snap) => {
        const map = {};
        snap.forEach((d) => {
          const v = d.data();
          map[`${v.hub}__${v.product_name}`] = v.stock;
        });
        setStockOverrides(map);
      },
      (error) => {
        console.error("Error fetching stock updates: ", error);
      }
    );
    return () => unsub();
  }, []);

  // Same id every time: date + hub + product -> overwrites the same document on each change
  const saveStockUpdate = async (item, stock) => {
    const todayDate = moment().format("YYYY-MM-DD");
    const hub = selectedHub === "All Hub" ? "ALL" : selectedHub;
    const id = `${todayDate}_${hub}_${item.product_name}`.replace(/[\/\s]+/g, "_");
    try {
      await setDoc(
        doc(db, "stockUpdates", id),
        {
          date: todayDate,
          hub,
          product_name: item.product_name,
          stock,
          updated_by: user?.email || user?.name || null,
          updated_at: new Date().toISOString(),
        },
        { merge: true }
      );
    } catch (e) {
      console.error("Failed to save stock update:", e);
    }
  };

  useEffect(() => {
    const todayDate = moment().format("YYYY-MM-DD");
    const unsubscribe = onSnapshot(
      doc(db, 'orderLocks', todayDate),
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setDeliveryList(data.deliveryList);
          setCummulativeDeliveryList(data.deliveryList);
          setFilteredHubDeliveryList(data.deliveryList);
        }
      },
      (error) => {
        console.error('Error fetching data: ', error);
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchLockStatus = async () => {
      const todayDate = moment().format("YYYY-MM-DD");
      const lockDocRef = doc(db, "orderLocks", todayDate);
      const docSnap = await getDoc(lockDocRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setIsLocked(data.isLocked);
        setLockedAt(data.lockedAt);
        setBufferPercentage(data.bufferPercentage || 0);
        if (data.deliveryList) {
          setFilteredHubDeliveryList(data.deliveryList);
          setCummulativeDeliveryList1(data.deliveryList);
          setCummulativeDeliveryList(data.deliveryList);
        }
      }
    };

    fetchLockStatus();
  }, []);

  const handleLockOrders = async () => {
    const now = new Date();
    const timestamp = now.toISOString();
    const todayDate = moment(now).format("YYYY-MM-DD");

    const lockDocRef = doc(db, "orderLocks", todayDate);

    try {
      const docSnap = await getDoc(lockDocRef);

      const deliveryList = filteredHubDeliveryList.length > 0 ? filteredHubDeliveryList : null;

      const lockPayload = {
        isLocked: true,
        lockedAt: timestamp,
        bufferPercentage,
        created_at: timestamp,
        created_date: todayDate,
        ...(deliveryList && { deliveryList }),
      };

      await setDoc(lockDocRef, lockPayload);
      setIsLocked(true);
      setLockedAt(timestamp);
    } catch (error) {
      console.error("Error locking orders:", error);
    }
  };

  const handleBufferChange = async (item, value) => {
    const updatedData = cummulativeDeliveryList1.map((row) => {
      if (getRowKey(row) !== getRowKey(item)) return row;

      const buffer = Math.max(0, Math.round(value));
      const final = (row.B2C_predicted_orders || 0) + (row.B2B_predicted_orders || 0) + buffer;
      return {
        ...row,
        buffer_added: buffer,
        final_order: final,
        stock_need_exceed: calcNeed(final, row.stock),
      };
    });

    setCummulativeDeliveryList1(updatedData);
    setFilteredHubDeliveryList(updatedData);

    if (selectedHub !== "All Hub") {
      setFilteredHubDeliveryList(updatedData.filter((itm) => itm.hubName === selectedHub));
    }

    if (isLocked) {
      try {
        const todayDate = moment().format("YYYY-MM-DD");
        await updateDoc(doc(db, "orderLocks", todayDate), { deliveryList: updatedData });
      } catch (error) {
        console.error("Failed to update locked data:", error);
      }
    }
  };

  // Handler for editing B2B Orders
  const handleB2BChange = async (item, value) => {
    const updatedData = cummulativeDeliveryList1.map((row) => {
      if (getRowKey(row) !== getRowKey(item)) return row;

      const b2bOrders = Math.max(0, Math.round(value));
      const final = (row.B2C_predicted_orders || 0) + b2bOrders + (row.buffer_added || 0);
      return {
        ...row,
        B2B_predicted_orders: b2bOrders,
        final_order: final,
        stock_need_exceed: calcNeed(final, row.stock),
      };
    });

    setCummulativeDeliveryList1(updatedData);
    setFilteredHubDeliveryList(updatedData);

    if (selectedHub !== "All Hub") {
      setFilteredHubDeliveryList(updatedData.filter((itm) => itm.hubName === selectedHub));
    }

    if (isLocked) {
      try {
        const todayDate = moment().format("YYYY-MM-DD");
        await updateDoc(doc(db, "orderLocks", todayDate), { deliveryList: updatedData });
      } catch (error) {
        console.error("Failed to update locked data:", error);
      }
    }
  };

  // Manual edit of Stock. Stock Need/Exceed auto-recalculates (final_order - stock, never negative).
  // Every change is saved to the "stockUpdates" collection on the same document id.
  // In the hub view only that hub's row changes.
  const handleStockChange = async (item, value) => {
    const stock = Math.max(0, Math.round(Number(value) || 0));
    const hit = (row) =>
      getRowKey(row) === getRowKey(item) &&
      (selectedHub === "All Hub" || row.hubName === selectedHub);
    const apply = (row) =>
      hit(row)
        ? { ...row, stock, stock_need_exceed: calcNeed(row.final_order, stock) }
        : row;

    saveStockUpdate(item, stock); // collection mein save/update

    if (selectedHub === "All Hub") {
      const updatedData = cummulativeDeliveryList1.map(apply);
      setCummulativeDeliveryList1(updatedData);
      setFilteredHubDeliveryList(updatedData);
      if (isLocked) {
        try {
          const todayDate = moment().format("YYYY-MM-DD");
          await updateDoc(doc(db, "orderLocks", todayDate), { deliveryList: updatedData });
        } catch (error) {
          console.error("Failed to update locked data:", error);
        }
      }
    } else {
      setHubWiesProduct((prev) => prev.map(apply));
    }
  };

  const handleHubChange = (e) => {
    setSelectedHub(e.target.value);
  };

  const filteredHubDeliveryList =
    selectedHub === "All Hub"
      ? cummulativeDeliveryList1
      : hubProducts.filter((item) => item.hubName === selectedHub);

  const handleBufferPercentageChange = (value) => {
    const newBufferPercentage = Math.max(0, Math.min(100, parseFloat(value)));
    setBufferPercentage(newBufferPercentage);

    if (selectedHub === "All Hub") {
      setCummulativeDeliveryList1((prevList) =>
        prevList.map((item) => {
          const bufferAdded = Math.round(
            (item.B2C_predicted_orders * newBufferPercentage) / 100
          );
          const finalOrder =
            item.B2C_predicted_orders + item.B2B_predicted_orders + bufferAdded;
          return {
            ...item,
            buffer_added: bufferAdded,
            final_order: finalOrder,
            stock_need_exceed: calcNeed(finalOrder, item.stock),
          };
        })
      );
    }
  };

  // Function to get product name with its unit
  const getProductDisplayName = (productName) => {
    const product = products?.find((p) => p.productName === productName);
    if (product?.packagingOptions?.[0]) {
      const { packaging, pkgUnit } = product.packagingOptions[0];
      return `${productName} (${packaging} ${pkgUnit})`; // Example: "Unsalted Butter (200 g)"
    }
    return productName;
  };

  // Default stock comes from stockData; manually saved stock (stockUpdates) takes priority.
  const handleDefaultStockChange = () => {
    const stockDataMap = stockData.reduce((acc, item) => {
      acc[item.productName] = (acc[item.productName] || 0) + item.goodStock;
      return acc;
    }, {});

    setCummulativeDeliveryList1((prevList) =>
      prevList.map((item) => {
        const ov = stockOverrides[`ALL__${item.product_name}`];
        const stock = ov !== undefined ? ov : stockDataMap[item.product_name] || 0;
        return {
          ...item,
          stock,
          stock_need_exceed: calcNeed(item.final_order, stock),
        };
      })
    );

    setHubWiesProduct((prevMap) =>
      prevMap.map((order) => {
        const hubStockData = stockData
          .filter(({ hub }) => hub === order.hubName)
          .reduce((acc, item) => {
            acc[item.productName] = (acc[item.productName] || 0) + item.goodStock;
            return acc;
          }, {});

        const ov = stockOverrides[`${order.hubName}__${order.product_name}`];
        const stock = ov !== undefined ? ov : hubStockData[order.product_name] || 0;
        return {
          ...order,
          stock,
          stock_need_exceed: calcNeed(order.final_order, stock),
        };
      })
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      handleDefaultStockChange();
      handleBufferPercentageChange(bufferPercentage);
      if (user.role === "Hub Manager") {
        setSelectedHub(user.hub_name);
      }
    };

    fetchData();
  }, [bufferPercentage, user, stockOverrides]);

  return (
    <>
      <div className="card p-1 mb-4">
        <div className="container my-2">
          <div className="d-flex flex-row justify-content-between align-items-start mt-1">
            <div className="d-flex flex-column gap-2">
              <h3 className="">Order Prediction</h3>
              <div className="d-flex align-items-center gap-3">
                <p className="text-black fs-4 mb-0">Date:</p>
                <p
                  style={{ width: "120px", fontSize: "16px", fontWeight: "bold", marginTop: "10px", padding: "8px", backgroundColor: "#F8F9FA", borderRadius: "0.375rem" }}
                >{moment().format('DD-MM-YYYY')}</p>
              </div>
            </div>

            {/* Hub Dropdown */}
            <div className="d-flex flex-column gap-2 align-items-end">
              <div className="mb-3">
                {/* Passed getProductDisplayName as a prop */}
                <MyComponent
                  filteredHubDeliveryList={filteredHubDeliveryList}
                  selectedHub={selectedHub}
                  handleBufferChange={handleBufferChange}
                  getProductDisplayName={getProductDisplayName}
                />
              </div>

              {user.role === "Admin" ? (
                <div className="d-flex gap-2 mb-1  align-items-center">
                  <h4 className="mt-2">Hub:</h4>
                  <div className="d-flex flex-row align-items-center">
                    <select
                      className="form-select"
                      value={selectedHub}
                      onChange={handleHubChange}
                    >
                      <option value="All Hub">All Hub</option>
                      {hubs.map((hub, index) => (
                        <option key={index} value={hub.hub_name}>
                          {hub.hub_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ) : (
                <div className="d-flex  gap-2 mb-3  align-items-center">
                  <h4 className="">Hub:</h4>
                  <h4 className="bg-light text-primary">{user.hub_name}</h4>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="card p-2 mb-2">
        <div className="container my-4">
          <div className="d-flex flex-row justify-content-between align-items-center mb-4">
            <h4 className="text-primary mb-0">Cumulative Hub Delivery List</h4>
            {selectedHub === "All Hub" && user.role === "Admin" && (
              <div className="d-flex  flex-row align-items-center ms-3 gap-2">

                {!isLocked ? (
                  <button
                    className="btn btn-danger ms-4"
                    onClick={handleLockOrders}
                  >
                    Confirm
                  </button>
                ) : (
                    <p className="text-muted mt-2  pe-3 ">Locked at: {moment(new Date(lockedAt)).format("DD-MM-YYYY hh:mm:ss")}</p>
                )}

                <input
                  type="number"
                  className="form-control"
                  value={bufferPercentage}
                  min="0"
                  max="100"
                  disabled={isLocked}
                  onChange={(e) => handleBufferPercentageChange(e.target.value)}
                  style={{
                    width: "80px",
                    padding: "0.5rem",
                    borderRadius: "0.375rem",
                    textAlign: "center",
                  }}
                />
                <span className="ms-2">%</span>
              </div>
            )}
          </div>

          <div className="table-responsive" style={{ overflowX: "auto" }}>
            <table
              className="table table-bordered position-relative"
              style={{ width: "100%", minWidth: "900px", tableLayout: "auto" }}
            >
              <thead className="bg-white">
                <tr>
                  <th className="text-start align-middle" style={{ whiteSpace: "nowrap" }}>
                    Product
                  </th>
                  <th className="text-center align-middle" style={{ whiteSpace: "nowrap" }}>
                    Predicted Orders (B2C)
                  </th>
                  <th className="text-center align-middle" style={{ whiteSpace: "nowrap" }}>
                    Predicted Orders (B2B)
                  </th>
                  {selectedHub === "All Hub" && (
                    <th className="text-center align-middle" style={{ whiteSpace: "nowrap" }}>
                      Added Buffer
                    </th>
                  )}
                  <th className="text-center align-middle" style={{ whiteSpace: "nowrap" }}>
                    Final Order
                  </th>
                  <th className="text-center align-middle" style={{ whiteSpace: "nowrap" }}>
                    Stock
                  </th>
                  <th className="text-center align-middle" style={{ whiteSpace: "nowrap" }}>
                    Stock Need/Exceed
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredHubDeliveryList && filteredHubDeliveryList.length > 0 ? (
                  [...filteredHubDeliveryList]
                    .sort((a, b) => a.product_name.localeCompare(b.product_name))
                    .map((item) => (
                      <tr key={getRowKey(item)} className="text-center">
                        <td className="text-start" style={{ whiteSpace: "nowrap" }} title={`Full details: ${item.product_name}`}>
                          {getProductDisplayName(item.product_name)}
                        </td>
                        <td className="align-middle">{item.B2C_predicted_orders}</td>
                        <td className="align-middle">
                          {/* B2B Editable Cell */}
                          <EditableCell
                            initialValue={item.B2B_predicted_orders}
                            onSave={(val) => handleB2BChange(item, val)}
                            disabled={isLocked}
                          />
                        </td>
                        {selectedHub === "All Hub" && (
                          <td className="align-middle">
                            {/* Buffer Editable Cell */}
                            <EditableCell
                              initialValue={item.buffer_added}
                              onSave={(val) => handleBufferChange(item, val)}
                              disabled={isLocked}
                            />
                          </td>
                        )}
                        <td className="align-middle">{item.final_order}</td>
                        <td className="align-middle">
                          {/* Stock Editable Cell */}
                          <EditableCell
                            initialValue={item.stock || 0}
                            onSave={(val) => handleStockChange(item, val)}
                            disabled={isLocked}
                          />
                        </td>
                        {/* Auto-calculated, never negative */}
                        <td className="align-middle">{calcNeed(item.final_order, item.stock)}</td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="alert alert-info">
        <strong>Note:</strong> The final order is calculated by adding the
        buffer to predicted orders, ensuring enough stock for each hub.
      </div>

      <style>{`
        input.no-spinner::-webkit-outer-spin-button,
        input.no-spinner::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input.no-spinner[type="number"] {
          -moz-appearance: textfield;
        }
        html, body {
          overflow-x: hidden;
        }
        .text-truncate {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        thead th {
          padding-top: 0.9rem;
          padding-bottom: 0.9rem;
        }
      `}</style>
    </>
  );
};

export default Orders;

// Passed getProductDisplayName here to map names properly
const convertToCSV = (data, selectedHub, getProductDisplayName) => {
  const headers =
    selectedHub === "All Hub"
      ? [
        "Product Name",
        "Predicted Orders (B2C)",
        "Predicted Orders (B2B)",
        "Buffer Added",
        "Final Order",
        "Stock",
        "Stock Need Exceed",
      ]
      : [
        "Product Name",
        "Predicted Orders (B2C)",
        "Predicted Orders (B2B)",
        "Final Order",
        "Stock",
        "Stock Need Exceed",
      ];
      
  const rows =
    selectedHub === "All Hub"
      ? data.map((item) => [
        getProductDisplayName ? getProductDisplayName(item.product_name) : item.product_name,
        item.B2C_predicted_orders,
        item.B2B_predicted_orders,
        item.buffer_added,
        item.final_order,
        item.stock,
        calcNeed(item.final_order, item.stock),
      ])
      : data.map((item) => [
        getProductDisplayName ? getProductDisplayName(item.product_name) : item.product_name,
        item.B2C_predicted_orders,
        item.B2B_predicted_orders,
        item.final_order,
        item.stock,
        calcNeed(item.final_order, item.stock),
      ]);

  // Product names mein comma ho sakta hai, isliye har cell ko quote kar diya
  const csvContent = [headers, ...rows]
    .map((row) => row.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  return csvContent;
};

// Passed getProductDisplayName as an argument
const exportToCSV = (filteredHubDeliveryList, selectedHub, getProductDisplayName) => {
  const table = document.getElementById("deliveryTable");
  table.style.display = "table"; 
  const csvData = convertToCSV(filteredHubDeliveryList, selectedHub, getProductDisplayName);
  const blob = new Blob([csvData], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = `${selectedHub}_delivery_list.csv`;

  link.click();
  table.style.display = "none"; 
};

const MyComponent = ({
  filteredHubDeliveryList,
  selectedHub,
  handleBufferChange,
  getProductDisplayName // Receiving prop here
}) => {
  return (
    <div>
      <Button
        className="btn btn-success btn-rounded btn-sm "
        onClick={() => exportToCSV(filteredHubDeliveryList, selectedHub, getProductDisplayName)}
      >
        Export to CSV
      </Button>

      <table id="deliveryTable" style={{ display: "none" }}>
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Predicted Orders (B2C)</th>
            <th>Predicted Orders (B2B)</th>
            <th>Buffer Added</th>
            <th>Final Order</th>
            <th>Stock</th>
            <th>Stock Need Exceed</th>
          </tr>
        </thead>
        <tbody>
          {filteredHubDeliveryList &&
            filteredHubDeliveryList.map((item, index) => (
              <tr key={getRowKey(item) + index} className="text-center">
                <td title={`Full details: ${item.product_name}`}>
                  {getProductDisplayName ? getProductDisplayName(item.product_name) : item.product_name}
                </td>
                <td>{item.B2C_predicted_orders}</td>
                <td>{item.B2B_predicted_orders}</td>
                <td>{item.buffer_added}</td>
                <td>{item.final_order}</td>
                <td>{item.stock}</td>
                <td>{calcNeed(item.final_order, item.stock)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};